import React from 'react';
import { Cell, Pie, PieChart } from 'recharts';

import type { DashboardCategorySlice } from '../types';
import { categoryHex } from '../utils/chartConfig';

type DashboardCategoryDonutProps = {
  categories: DashboardCategorySlice[];
};

const DONUT_SIZE = 120;

export function DashboardCategoryDonut({ categories }: DashboardCategoryDonutProps) {
  const total = categories.reduce((sum, c) => sum + c.count, 0);

  if (total === 0) {
    return (
      <div className="flex h-full items-center justify-center text-xs text-slate-400">
        Keine Kategorien
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="relative h-[120px] w-[120px]">
        <PieChart width={DONUT_SIZE} height={DONUT_SIZE}>
          <Pie
            data={categories}
            dataKey="count"
            nameKey="label"
            cx="50%"
            cy="50%"
            innerRadius={40}
            outerRadius={56}
            paddingAngle={categories.length > 1 ? 2 : 0}
            stroke="none"
          >
            {categories.map((slice) => (
              <Cell key={slice.key} fill={categoryHex(slice.color)} />
            ))}
          </Pie>
        </PieChart>
        <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-lg font-bold text-app-text sm:text-xl">{total.toLocaleString('de-DE')}</span>
          <span className="text-[11px] font-medium text-slate-400">Anfragen</span>
        </div>
      </div>
      <ul className="w-full space-y-1.5">
        {categories.map((slice) => (
          <li key={slice.key} className="flex items-center justify-between gap-2 text-xs">
            <span className="flex items-center gap-1.5 text-app-text-muted">
              <span className="inline-block h-2.5 w-2.5 rounded-sm" style={{ background: categoryHex(slice.color) }} />
              <span className="truncate">{slice.label}</span>
            </span>
            <span className="font-semibold text-app-text">{slice.count.toLocaleString('de-DE')}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
